export default __webpack_public_path__ + "static/CollectiveHaus_2023_VideoLoader-458dbc2109c0895ff66ac697c47db590.jpg";